import { Container, Grid } from "@material-ui/core";
import React from "react";

interface ModalPageWrapperProps {
  children: React.ReactNode;
  alignItems: "flex-start" | "flex-end" | "center";
}

const ModalPageWrapper: React.FC<ModalPageWrapperProps> = ({
  children,
  alignItems = "flex-start",
}) => {
  return (
    <Container>
      <Grid container justifyContent="center" alignItems={alignItems}>
        <div className="modal-page__wrapper">
          <div className="modal-page__content-container">{children}</div>
        </div>
      </Grid>
    </Container>
  );
};

export default ModalPageWrapper;
